var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 130,
    viewBox: "0 0 133 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_10268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.983 21.5623C14.8857 42.722 26.3994 61.8185 43.9919 74.652C61.5845 87.4854 83.8152 93.0048 105.795 89.9963L90.614 109.189C90.0736 109.949 89.8549 110.877 90.0033 111.781C90.1516 112.686 90.6555 113.497 91.4106 114.047C92.1658 114.597 93.1144 114.843 94.06 114.736C95.0056 114.628 95.8758 114.175 96.4904 113.469L117.115 87.3941C117.412 87.0191 117.63 86.5922 117.756 86.1377C117.883 85.6832 117.915 85.21 117.852 84.7453C117.789 84.2805 117.631 83.8332 117.388 83.429C117.145 83.0248 116.821 82.6716 116.434 82.3896L89.595 62.7698C89.209 62.4877 88.7683 62.2821 88.2982 62.1649C87.828 62.0477 87.3376 62.0212 86.8549 62.0869C86.3722 62.1525 85.9067 62.309 85.4849 62.5475C85.0632 62.786 84.6934 63.1018 84.3968 63.4768C84.1001 63.8518 83.8824 64.2788 83.7561 64.7332C83.6298 65.1877 83.5973 65.6608 83.6605 66.1255C83.7237 66.5902 83.8814 67.0374 84.1245 67.4416C84.3676 67.8459 84.6914 68.1991 85.0774 68.4813L104.833 82.9228C84.8018 85.6663 64.5413 80.6379 48.507 68.9436C32.4728 57.2494 21.9779 39.8467 19.3304 20.563C19.2028 19.625 18.6934 18.7781 17.9142 18.2085C17.1351 17.639 16.15 17.3934 15.1757 17.5259C14.2014 17.6584 13.3176 18.1581 12.7189 18.9151C12.1202 19.6721 11.8555 20.6243 11.983 21.5623Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_10268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114.218,
    height: 118.64,
    fill: "white",
    transform: "translate(15.3926 129.164) rotate(-97.7451)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1);
export default __webpack_public_path__ + "static/media/arrow1.5da2d767be6ed79e1344f77fb4fc86bf.svg";
export { ForwardRef as ReactComponent };